$(function () {
    $('.resources-content').on('click', '.popover-close', function () {
        var popoverID = '#' + $(this).data('popover');
        $(popoverID).popover('hide');
    });

    $('.show-resource-settings').click(function () {
        $('.show-resource-settings').popover('destroy');
        $(this).popover('show');
        var timeout;
        timeout = setTimeout(function () {
            $('.show-resource-settings').popover('destroy');
        }, 10000);
        $('.popover').mouseleave(function () {
            timeout = setTimeout(function () {
                $('.show-resource-settings').popover('destroy');
            }, 10000);
        });
        $('.popover').mouseenter(function () {
            clearTimeout(timeout);
        });
    });

    $('#resource-filter-button').on('click', function () {
        $('.resource-filter').slideToggle();
    });

    let isEditMode = false;
    let originalSummaryContent = '';

    $('#buttonContainer, #editSummaryTextLabel').hide();

    function initialiseSummernote() {
        const customToolbar = [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['misc', ['link']],
            ['para', ['ul', 'ol']],
            ['misc', ['undo', 'redo']],
        ];

        const placeholderText = 'Enter a page summary';

        $('#summary').summernote({
            id: 'editSummarySummernote',
            toolbar: customToolbar,
            placeholder: placeholderText,
        });
    }

    function enterEditMode() {
        if (!isEditMode) {
            initialiseSummernote();
            isEditMode = true;
            $('#buttonContainer, #editSummaryTextLabel').show();
            originalSummaryContent = $('#summary').summernote('code');
        }
    }

    function exitEditMode() {
        $('#summary').summernote('destroy');
        isEditMode = false;
        $('#summernoteEditor, #buttonContainer, #editSummaryTextLabel').hide();
    }

    $('#editSummary').on('click', function () {
        enterEditMode();
    });

    $('#saveSummary').on('click', function () {
        if (isEditMode) {
            let editedSummary = $('#summary').summernote('code');
            let pageId = $('#pageId').val();
            let pageName = $('#pageName').val();

            let data = {
                id: pageId,
                name: pageName,
                summary: editedSummary,
                myvle_csrf_test_name: csrfToken,
            };

            const editPageUrl = base_url + 'pages/ajax_editpagesummary';

            $.ajax({
                type: 'POST',
                url: editPageUrl,
                data: data,
                dataType: 'json',
                success: function (response) {
                    if (response.successcode === 1) {
                        showStatusMessage('success', response.message);
                    } else {
                        showStatusMessage('error', response.message);
                    }
                },
                error: function () {
                    showStatusMessage('error', 'Error. Failed to Save');
                },
            });

            exitEditMode();
        }
    });

    $('#cancelEdit').on('click', function () {
        if (isEditMode) {
            $('#summary').summernote('code', originalSummaryContent);
            exitEditMode();
        }
    });

    function showStatusMessage(type, statusMessage) {
        const $messageElement = $('#summary-save-message');
        const iconClass = type === 'success' ? 'check-circle' : 'circle-xmark';
        const labelClass = type === 'success' ? 'label-success' : 'label-danger';

        $messageElement.removeClass('label-success label-danger').addClass(labelClass);
        $messageElement.html(`<i class="${FontAwesome.prefix('regular', iconClass)}"></i> ${statusMessage}`);
        $messageElement.clearQueue().stop().fadeIn('slow').delay(2000).fadeOut('slow');
    }
});
